import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ContestExportSettingAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('contest');
  }
}
